<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="businessDetailServiceInfo.servs" border style="width: 100%">
        <el-table-column prop="servId" label="服务编号" align="center"></el-table-column>
        <el-table-column prop="servName" label="服务名称" align="center"></el-table-column>
        <el-table-column prop="servDesc" label="服务描述" align="center"></el-table-column>
        <el-table-column prop="hktName" label="服务类型" align="center"></el-table-column>
        <el-table-column label="派单方式" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.repairWay === '100'">抢单</span>
            <span v-else-if="scope.row.repairWay === '200'">指派</span>
            <span v-else-if="scope.row.repairWay === '300'">轮训</span>
          </template>
        </el-table-column>
        <el-table-column label="回访方式" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.returnVisitFlag === '001'">都不回访</span>
            <span v-else-if="scope.row.returnVisitFlag === '002'">已评价不回访</span>
            <span v-else-if="scope.row.returnVisitFlag === '003'">都回访</span>
          </template>
        </el-table-column>
        <el-table-column prop="sales" label="销量" align="center"></el-table-column>
        <el-table-column prop="defaultFee" label="默认费用" align="center"></el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column label="上架状态" align="center">
          <template slot-scope="scope">
            {{scope.row.state === '1001'?'未上架':'上架'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="8"></el-col>
        <el-col :span="16" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    businessDetailServiceInfo: {
      type: Object,
      default: () => ({
        servs: [],
        link: ''
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('page-change', val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}
.text-right {
  text-align: right;
}
</style>